__turbopack_context__.v({
  "acheivername": "careers-module__g9bnza__acheivername",
  "acheiverrank": "careers-module__g9bnza__acheiverrank",
  "attachment": "careers-module__g9bnza__attachment",
  "captcha": "careers-module__g9bnza__captcha",
  "checkboxcontent": "careers-module__g9bnza__checkboxcontent",
  "contactbox": "careers-module__g9bnza__contactbox",
  "contactboxheight": "careers-module__g9bnza__contactboxheight",
  "contactsubcontent": "careers-module__g9bnza__contactsubcontent",
  "customFileUploader": "careers-module__g9bnza__customFileUploader",
  "formstar": "careers-module__g9bnza__formstar",
  "imgboxbelow": "careers-module__g9bnza__imgboxbelow",
  "input-group-btn": "careers-module__g9bnza__input-group-btn",
  "invalidCheck2": "careers-module__g9bnza__invalidCheck2",
  "mobilemaillinks": "careers-module__g9bnza__mobilemaillinks",
  "normalbutton": "careers-module__g9bnza__normalbutton",
  "pagemaintitle": "careers-module__g9bnza__pagemaintitle",
  "redunderline": "careers-module__g9bnza__redunderline",
  "sectiontitle": "careers-module__g9bnza__sectiontitle",
  "selected": "careers-module__g9bnza__selected",
});
